module.exports = __webpack_public_path__ + "img/sankaku_20_blue.1e7e96d8.png";